@let title = isEmail() ? ("email.title" | translate) : ("pdfHandler.title" | translate);
<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content fxLayout="column" fxLayoutGap="16px">
    <div fxLayout="column" class="p-t-lg">
        @let showBundleOption = !isPrint() && data.entityInstances.length >= 2;
        @if (showBundleOption) {
            <mat-checkbox [checked]="isBundleDocuments()" (change)="isBundleDocuments.set($event.checked)">
                {{ "pdfHandler.bundleDescription" | translate }}
            </mat-checkbox>
        }

        <mat-checkbox [checked]="isIncludeActivity()" (change)="isIncludeActivity.set($event.checked)">
            {{ "pdfHandler.includeActivityDescription" | translate }}
        </mat-checkbox>

        <mat-checkbox [checked]="isIncludeDocumentAttachments()" (change)="isIncludeDocumentAttachments.set($event.checked)">
            {{ "pdfHandler.includeDocumentAttachmentsDescription" | translate }}
        </mat-checkbox>

        <mat-checkbox [checked]="isIncludeActivityAttachments()" (change)="isIncludeActivityAttachments.set($event.checked)">
            {{ "pdfHandler.includeActivityAttachmentsDescription" | translate }}
        </mat-checkbox>
    </div>

    @if (showTemplates()) {
        <mat-form-field appearance="outline">
            <mat-label>{{ "pdfHandler.template" | translate }}</mat-label>
            <mat-select [ngModel]="selectedTemplateId()" (ngModelChange)="selectedTemplateId.set($event)">
                @for (template of templates(); track template.key) {
                    <mat-option [value]="template.key">
                        {{ template.value }} {{ template.isPrimary ? "(default)" : "" }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    }
</mat-dialog-content>

@let confirmLabel =
    isEmail()
        ? ("email.proceed" | translate)
        : isPrint()
          ? ("pdfHandler.print" | translate)
          : ("pdfHandler.download" | translate);
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ "pdfHandler.cancel" | translate }}</button>
    <button mat-flat-button color="primary" (click)="onConfirm()" [disabled]="isLoading() || !selectedTemplateId()">
        {{ isLoading() ? ("messages.loading.processing" | translate) : confirmLabel }}
    </button>
</mat-dialog-actions>
